"use client";

import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectHasLayoutDraft } from "@store/features/crm/pageV2Slice";
import {
  clearLayoutModifiedToast,
  isLayoutModifiedToastDismissed,
  showLayoutModifiedToast,
} from "@schemas/pages/layout/layoutModifiedToast";
import { savePageLayoutDraft } from "@schemas/pages/layout/savePageLayoutDraft";

export function LayoutModifiedToastManager() {
  const hasLayoutDraft = useSelector(selectHasLayoutDraft);

  useEffect(() => {
    if (!hasLayoutDraft) {
      clearLayoutModifiedToast();
      return;
    }

    if (!isLayoutModifiedToastDismissed()) {
      showLayoutModifiedToast();
    }
  }, [hasLayoutDraft]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (!hasLayoutDraft) {
        return;
      }
      if (
        !(event.metaKey || event.ctrlKey) ||
        event.key.toLowerCase() !== "s"
      ) {
        return;
      }
      event.preventDefault();
      void savePageLayoutDraft();
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [hasLayoutDraft]);

  return null;
}
